export const CANCEL_DEVICE_MODAL_FORM = 'CANCEL_DEVICE_MODAL_FORM'

export const CANCEL_DEVICE_LEAD_TIME_INFO_ID = 'cancel-device-lead-time-info'
export const CANCEL_DEVICE_DATE_PICKER_ID = 'cancel-device-date-picker'

/** Maximum months in the future for scheduling a cancellation */
export const MAX_SCHEDULED_CANCELLATION_MONTHS = 18

export const CANCEL_DEVICE_FORM_FIELDS = {
  CANCELLATION_TYPE: 'cancellationType',
  MESSAGE: 'message',
  SCHEDULED_DATE: 'scheduledDate',
} as const
